export enum Mode {
  Create = 'create',
  Edit = 'edit',
  Cancel = 'cancel',
}

export type TradeVariant = 'offer' | 'bid';
